import { InputProps } from '../Input';

export const EMAIL = 'email' as const;
export const PASSWORD = 'password' as const;

export type EMAIL = typeof EMAIL;
export type PASSWORD = typeof PASSWORD;

export interface LoginInputProps extends Omit<InputProps, 'icon' | 'iconPosition'> {
  /**
   * The type of login input (email or password)
   */
  loginType: EMAIL | PASSWORD;
}

export type LoginInputType = EMAIL | PASSWORD;
